import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  FaHome,
  FaUsers,
  FaServicestack,
  FaProjectDiagram,
  FaBriefcase,
  FaEnvelope,
  FaSignOutAlt,
  FaBars,
  FaTimes
} from 'react-icons/fa';
import './AdminLayout.css';

const AdminLayout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logout, admin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: <FaHome /> },
    { path: '/admin/founders', label: 'Founders', icon: <FaUsers /> },
    { path: '/admin/services', label: 'Services', icon: <FaServicestack /> },
    { path: '/admin/projects', label: 'Projects', icon: <FaProjectDiagram /> },
    { path: '/admin/careers', label: 'Careers', icon: <FaBriefcase /> },
    { path: '/admin/contacts', label: 'Messages', icon: <FaEnvelope /> }
  ];

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">Cascade India</h2>
          <button className="sidebar-toggle" onClick={() => setSidebarOpen(false)}>
            <FaTimes />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="sidebar-icon">{item.icon}</span>
              <span className="sidebar-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="admin-main">
        <header className="admin-header">
          <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)}>
            <FaBars />
          </button>
          <h1 className="admin-page-title">{title}</h1>
          <div className="admin-user">
            <span className="user-name">{admin?.name || 'Admin'}</span>
          </div>
        </header>

        <main className="admin-content">{children}</main>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>
      )}
    </div>
  );
};

export default AdminLayout;
